import React from 'react';
import {useTranslation} from 'react-i18next';
import styles from './ButtonEffects.module.css';
import {useRippleEffect} from '../../hooks/useRippleEffect';

type Props = {
	isActive: boolean;
	onClick: () => void;
	activeText?: string;
	inactiveText?: string;
	variant?: 'green' | 'blue' | 'brown';
	className?: string;
};

const FilterToggleButton: React.FC<Props> = ({
	isActive,
	onClick,
	activeText,
	inactiveText,
	variant = 'green',
	className = '',
}) => {
	const {t} = useTranslation();
	const {ripples, createRipple} = useRippleEffect();

	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		createRipple(e);
		onClick();
	};

	const getButtonClasses = () => {
		const baseClasses = `filter-team__btn-plus btn-main btn-main-plus ${isActive ? 'active' : ''} ${className}`;
		const variantClasses = {
			green: styles.lightGreenButton,
			blue: styles.blueButton,
			brown: styles.brownButton,
		};
		
		return `${baseClasses} ${variantClasses[variant]}`;
	};

	const getPlusIconClasses = () => {
		return isActive ? `${styles.plusIcon} ${styles.active}` : styles.plusIcon;
	};

	return (
		<div
			role="button"
			tabIndex={0}
			onClick={handleClick}
			onKeyDown={(e) => {
				if (e.key === 'Enter' || e.key === ' ') {
					e.preventDefault();
					handleClick(e as any);
				}
			}}
			className={getButtonClasses()}
		>
			<span className={getPlusIconClasses()}></span>
			{isActive ? (activeText || t('закрити')) : (inactiveText || t('додати фільтр'))}
			{ripples.map(ripple => (
				<span
					key={ripple.id}
					className={styles.ripple}
					style={{
						left: ripple.x - 10,
						top: ripple.y - 10,
					}}
				/>
			))}
		</div>
	);
};

export default FilterToggleButton;
